(function () {
    'use strict';

    angular.module("imApp").factory("docPackTypesService", [function () {
        let service = {};

        return service;
    }]);
})();
